

import api, { Notifiable } from './api';

export interface ControleRfa {
  numero: string
  planilhaRfa: string
  statusPlanilhaRfaNome: string
  statusPlanilhaRfaCodigo: number
}


export interface ProgramaControleRfa {
  id: string;
  numeroLinha: number;
  nomePrograma: string
  planilhaRfa: string
}


export interface Programa extends Notifiable {
  nome: string
  controleRfa: string
}

export const getAllProjetoPlanilhaRfaAtual = () => { return api.get<ControleRfa[]>('programa/getAllProjetoPlanilhaRfaAtual'); }
export const getAllPrograma = () => { return api.get<ProgramaControleRfa[]>('programa/getAllPrograma'); }
export const creatPrograma = (value: Programa) => api.post<Programa>('programa', value);
export const deletePrograma = (id: string) => api.delete<Notification>(`programa/delete/${id}`);